import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';

export interface ErrorInterface {
  detail: string;
  timestamp?: Date;
}

@Module({ namespaced: true })
class Errors extends VuexModule {
  public errors: ErrorInterface[] = [];

  @Mutation
  public setErrors(errors: ErrorInterface[]): void {
    this.errors = errors;
  }

  @Action
  public updateErrors(errors: ErrorInterface[]) {
    if (errors) {
      this.context.commit('setErrors', errors.map(error => ({
        ...error,
        timestamp: error.detail.startsWith("Onverwachte systeemfout") ? new Date() : undefined
      })));
    }
  }

  @Action
  public resetErrors() {
    this.context.commit('setErrors', []);
  }

  get getErrors() {
    return this.errors;
  }
}

export default Errors;
